export default __webpack_public_path__ + "static/media/announcement_1@3x.c0400b9e.png";